import { FC, Fragment } from 'react';

import { FeventExtraSchedule } from '@shared/api/fevent/fevent.interface';
import { formatFeventDateString } from '@shared/utils/formatDate';

//* 추가 일정(영결식·입관예배 등) 행 — 고정 행(입실/입관/발인)과 같은 규격, 앵커 고정 행이 비어 있어도 그 자리에 그린다
//* 부고장(요일 표시)과 관리자 부고정보(요일 없음)가 같이 쓴다
export const ExtraScheduleRows: FC<{
  list: FeventExtraSchedule[];
  dayShow?: boolean;
}> = ({ list, dayShow = false }) => (
  <>
    {list.map((item, index) => (
      <Fragment key={item._id ?? `${item.label}-${index}`}>
        <p className="break-keep font-bold text-gray-500">{item.label}</p>
        <p className="font-normal">{formatFeventDateString(item, true, dayShow)}</p>
      </Fragment>
    ))}
  </>
);
